import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

function findAncestorParam(snapshot: ActivatedRouteSnapshot, key: string): string | undefined {
  let s: ActivatedRouteSnapshot | null = snapshot;
  while (s) {
    const v = s.paramMap.get(key);
    if (v !== null && v !== '') {
      return v;
    }
    s = s.parent;
  }
  return undefined;
}

/**
 * Default Angular reuse keeps the same component instance when only **parent** route params change
 * (e.g. `/user/:userId/VIKINGSE/dashboard` → `/user/:userId/VIKINGNO/dashboard`). That leaves dashboard
 * (and other leaf routes) showing stale data after an in-app market/business switch. When the leaf
 * route config is the same but `organizationId`, `businessId`, or `userId` in an ancestor differs,
 * do not reuse the activated route.
 */
export class MyPagesRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean {
    return false;
  }

  store(): void {}

  shouldAttach(): boolean {
    return false;
  }

  retrieve(): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }

    const orgFuture = findAncestorParam(future, 'organizationId');
    const orgCurr = findAncestorParam(curr, 'organizationId');
    if (orgFuture !== orgCurr) {
      return false;
    }

    const bizFuture = findAncestorParam(future, 'businessId');
    const bizCurr = findAncestorParam(curr, 'businessId');
    if (bizFuture !== bizCurr) {
      return false;
    }

    const userFuture = findAncestorParam(future, 'userId');
    const userCurr = findAncestorParam(curr, 'userId');
    if (userFuture !== userCurr) {
      return false;
    }

    return true;
  }
}
